export const ROUTES = {
    HOME: "/",
    TOOLBOX: "/toolbox",

    ADS: "/annonces",
    PROVIDERS: "/prestataires",
    CONTACT: "/contact",

    LOGIN: "/connexion",
    REGISTER: "/inscription",
    FORGOT_PASSWORD: "/mot-de-passe-oublie",

    ACCOUNT: "/mon-compte",
    ACCOUNT_PROFILE: "/mon-compte/profil/",
    MESSAGING: "/messagerie",
    NOTIFICATIONS: "/notifications",
    OTHER_PROFILE: "/profil",
    FAVORITES: "/mon-compte/mes-favoris/",

    MY_ADS: "/mon-compte/mes-annonces/",
    MY_ADS_CREATE: "/mon-compte/mes-annonces/ajouter",

    MY_SERVICES: "/mon-compte/mes-services/",
    MY_SERVICES_CREATE: "/mon-compte/mes-services/ajouter",

    SERVICE_HISTORY: "/mon-compte/historique/",

    MY_RESERVATIONS: "/mes-reservations",

    ADMIN: "/admin",

    LANDING: "/landing",

    ABOUT: "/a-propos",

    SERVICES: "/services",

    FAQ: "/faq",

    COMPANIES: "/entreprises",
} as const;

export const REGISTER_STEPS = {
    USER: "particulier",
    USER_SERVICES: "particulier/services",
    USER_INFORMATIONS: "particulier/informations",
    USER_CREDENTIALS: "particulier/identifiants",
    USER_CONFIRMATION: "particulier/confirmation",

    PROVIDER: "prestataire",
    PROVIDER_SERVICES: "prestataire/services",
    PROVIDER_INFORMATIONS: "prestataire/informations",
    PROVIDER_CREDENTIALS: "prestataire/identifiants",
    PROVIDER_CONFIRMATION: "prestataire/confirmation",

    EMPLOYEE: "salarie",
    ENTREPRISE: "entreprise",
    CONFIRMATION: "confirmation",
} as const;

export const RESERVATION_STEPS = {
    LOGIN: "se-connecter",
    SET_CLIENT: "mise-a-jour-client",
    SUMMARY: "recapitulatif",
    PAYMENT: "paiement",
    CONFIRM: "confirmation",
} as const;

export const buildRoute = {
    servicesByCategory: (categoryLabel: string, subCategoryLabel: string) =>
        `/services/${categoryLabel}/${subCategoryLabel}`,

    stripeRedirect: (accountStripeId: string) => `/redirection_stripe/${accountStripeId}`,

    resetPassword: (token: string) => `/reinitialisation-mot-de-passe/${token}`,

    validateEmail: (token: string) => `/confirmation-inscription/${token}`,

    otherProfile: (id: string | number) => `${ROUTES.OTHER_PROFILE}/${id}`,

    messaging: (serviceId: string, clientId: string) => `${ROUTES.MESSAGING}/${serviceId}/${clientId}/messages`,
    messagingAd: (serviceId: string, clientId: string, adId: string) =>
        `${ROUTES.MESSAGING}/${serviceId}/${clientId}/messages?ad=${encodeURIComponent(adId)}`,
    messagingOffer: (serviceId: string, clientId: string, adId: string) =>
        `${ROUTES.MESSAGING}/${serviceId}/${clientId}/messages?ad=${adId}&offer=1`,

    provider: (id: string | number) => `${ROUTES.PROVIDERS}/${id}`,

    ad: (id: string | number) => `${ROUTES.ADS}/${id}`,

    loginWithRedirect: (redirectTo: string) => `${ROUTES.LOGIN}?redirect=${encodeURIComponent(redirectTo)}`,

    contactWithSubject: (subject: string) => `${ROUTES.CONTACT}?subject=${encodeURIComponent(subject)}`,

    registerWithRedirect: (redirectTo: string) => `${ROUTES.REGISTER}?redirect=${encodeURIComponent(redirectTo)}`,

    admin: (path: string) => `${ROUTES.ADMIN}/${path}`,

    registerSub: (subPath: string) => `${ROUTES.REGISTER}/${subPath}`,

    myServicesEdit: (id: string | number) => `${ROUTES.MY_SERVICES}/${id}/modifier`,
    myApplications: () => `${ROUTES.ACCOUNT}/mes-candidatures/`,

    myAdEdit: (id: string | number) => `${ROUTES.MY_ADS}/${id}/modifier`,
    myAdDetails: (id: string | number) => `${ROUTES.MY_ADS}/${id}/details`,
    myAdApplications: (id: string | number) => `${ROUTES.MY_ADS}/${id}/candidatures`,

    serviceHistoryDetail: (id: string | number) => `${ROUTES.SERVICE_HISTORY}${id}`,

    myReservationResume: (id: string | number) => `${ROUTES.MY_RESERVATIONS}/${id}/resume`,
    myReservationPayment: (id: string | number) => `${ROUTES.MY_RESERVATIONS}/${id}/paiement`,
    myReservationDetails: (id: string | number) => `${ROUTES.MY_RESERVATIONS}/${id}/details`,
    myReservationMessages: (serviceId: string | number, clientId: string | number) =>
        `${ROUTES.MY_RESERVATIONS}/${serviceId}/${clientId}/messages`,

    providerReservation: (serviceId: string | number, step: string) =>
        `${ROUTES.PROVIDERS}/${serviceId}/reservation/${step}`,
} as const;
